module.exports = __webpack_public_path__ + "img/gift.0cc8c3a3.svg";